import type { PropsWithChildren } from 'react';
import React from 'react';

import { SubHeader, Loader } from '@/js/libs/ui';

import ErrorComponent from '../Error';
import type { NavItemProps } from './NavItem';
import NavItem from './NavItem';

type SceneSubHeaderProps = PropsWithChildren<{
  items: NavItemProps[];
  pending?: boolean;
  error?: string;
}>;

const SceneSubHeader = ({ children, error, items, pending }: SceneSubHeaderProps) => {
  if (pending) {
    return <Loader type='contain' />;
  }

  if (error) {
    return <ErrorComponent title={error} />;
  }

  return (
    <SubHeader fluid>
      <SubHeader.Nav>
        {items.map((item) => (
          <NavItem key={item.to} {...item} />
        ))}
      </SubHeader.Nav>
      {children}
    </SubHeader>
  );
};

SceneSubHeader.displayName = 'SceneSubHeader';

export default React.memo(SceneSubHeader) as typeof SceneSubHeader;

export type { NavItemProps };
